export default "__VITE_ASSET__Ck1_7bBm__"